import ProjectModel, {ProjectUploadModel} from "../../models/responses/project.model";
import {useTypedSelector} from "./selectors.utils";
import {Maybe} from "@martin_hotell/rex-tils";
import { ProjectLoadingStage } from "../reducers/project";
import {RiskModel, RiskUploadModel} from "../../models/responses/risk.model";

// Projects
export const useProjectListSelector = () => useTypedSelector<ProjectModel[]>(state => state.project.projectList);
export const useArchiveProjectListSelector = () => useTypedSelector<ProjectModel[]>(state => state.project.archiveProjectList);
export const useActiveProjectSelector = () => useTypedSelector<Maybe<ProjectModel>>(state => state.project.activeProject);
export const useIsLoadedProjectListSelector = () => useTypedSelector<boolean>(state => state.project.projectListLoaded);
export const useIsLoadedActiveProjectSelector = () => useTypedSelector<boolean>(state => state.project.activeProjectLoaded);
export const useUploadingNewProject = () => useTypedSelector<boolean>(state => state.project.uploadingNewProject);

export const useCpmCompleteSelector = () => useTypedSelector<boolean>(state => state.project.cpmComplete);

export const useCpmMapSelector = () => useTypedSelector<Map<string, any>>(state => state.project.cpmMap);

export const useActiveProjectCalendarsSelector = () => useTypedSelector<Map<string, any>>(state => state.project.activeProjectCalendars);

export const useTrackedMilestonesSelector = () => useTypedSelector<any[]>(state => state.project.trackedMilestones);

export const useMonteCarloIndexSelector = () => useTypedSelector<number>(state => state.project.monteCarloIndex);


export const useUploadingNewProjectProgressPercent = () => useTypedSelector<number>(state =>
Math.round((state.project.detectedSteps.uploadedWrites / state.project.detectedSteps.totalWrites) * 100)
);
export const useProjectLoadingStageSelector = () => useTypedSelector<ProjectLoadingStage>(state => state.project.projectLoadingStage);
export const useProjectCalculationsInProcessSelector = () => useTypedSelector<boolean>(state => state.project.calculationsInProcess);

export const useProjectViewSelector = () => useTypedSelector<string>(state => state.project.view);

export const useActiveProjectQualitySelector = () => useTypedSelector<any>(state => state.project.activeProjectQuality);

export const useGeoDataSelector = () => useTypedSelector<any>(state => state.project.geoData);

export const useActiveGeoSelector = () => useTypedSelector<any>(state => state.project.activeGeo);

export const useChatLogSelector = () => useTypedSelector<any[]>(state => state.project.chatLog);

export const useChatInitialisedSelector = () => useTypedSelector<boolean>(state => state.project.chatInitialised);

export const useVectorStoreSelector = () => useTypedSelector<any>(state => state.project.vectorStore);

export const useLedgerOpenSelector = () => useTypedSelector<boolean>(state => state.project.ledgerOpen);

export const useCalendarOpenSelector = () => useTypedSelector<boolean>(state => state.project.calendarOpen);

export const useTeamOpenSelector = () => useTypedSelector<boolean>(state => state.project.teamOpen);

export const useMonteCarloResultsSelector = () => useTypedSelector<any>(state => state.project.monteCarloResults);

export const useDataVersionsSelector = () => useTypedSelector<any[]>(state => state.project.dataVersions);

export const useActiveDataVersionSelector = () => useTypedSelector<any>(state => state.project.activeDataVersion);

export const useOpenTaskDetailsSelector = () => useTypedSelector<boolean>(state => state.project.showTaskDetails);

export const useViewWidthSelector = () => useTypedSelector<number>(state => state.project.viewWidth);

export const useSprintDataSelector = () => useTypedSelector<any>(state => state.project.sprintData);

export const useProjectUploadSelector = () => useTypedSelector<ProjectUploadModel[]>(state => state.project.projectUploads);

export const useProjectDagSelector = () => useTypedSelector<any>(state => state.project.projectDag);

export const useDagOpenSelector = () => useTypedSelector<boolean>(state => state.project.showNetworkDag);

export const useChecklistMapSelector = () => useTypedSelector<Map<string, any>>(state => state.project.checklistMap);

export const useClientIdSelector = () => useTypedSelector<string | null>(state => state.project.clientId);

export const useFrozenWarningSelector = () => useTypedSelector<boolean>(state => state.project.showFrozenWarning);

export const useProjectRiskSelector = () => useTypedSelector<RiskModel[]>(state => state.project.risks);

export const useRiskUploadSelector = () => useTypedSelector<RiskUploadModel | null>(state => state.project.riskUpload);

export const useProjectVersionsSelector = () => useTypedSelector<any[]>(state => state.project.projectVersions);

export const useRiskMappingSelector = () => useTypedSelector<any>(state => state.project.riskMapping);

export const useLivePlaylistSelector = () => useTypedSelector<any>(state => state.project.livePlaylist);

export const useLivePlaylistUpdateCountSelector = () => useTypedSelector<number>(state => state.project.livePlaylistUpdateCount);

export const useCompletedPlaylistItemsMapSelector = () => useTypedSelector<Map<string, any>>(state => state.project.completedPlaylistItemsMap);

export const useCurrentPlaylistItemSelector = () => useTypedSelector<any>(state => state.project.currentPlaylistItem);

export const useSkippedPlaylistItemsMapSelector = () => useTypedSelector<Map<string, any>>(state => state.project.skippedPlaylistItemsMap);

export const useFunctionMapSelector = () => useTypedSelector<Map<string, any>>(state => state.project.functionsMap);